<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" title="Volver" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" type="submit" class="btn btn-outline-success" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4>{{editTitle}} Usuario Cexveg</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <a class="card-header-a" (click)="isCollapsedDatosUser = !isCollapsedDatosUser"
                       [attr.aria-expanded]="!isCollapsedDatosUser" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Datos de Usuario
                            <i *ngIf="isCollapsedDatosUser" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedDatosUser" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body-detalle">

                        <div class="collapse group-filtros" id="isCollapsedDatosUser" [ngbCollapse]="isCollapsedDatosUser">

                            <div class="row">

                                <div class="form-group col-md-4">

                                    <label class="col-form-label required-field" for="inpNombre">Nombre</label>
                                    <input class="form-control" formControlName="Nombre" maxlength="100"
                                           inputStyleClass="form-control" type="text" value=""
                                           [ngClass]="displayFieldCss('Nombre')">

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('Nombre','required')">
                                        El Nombre es obligatorio
                                    </div>

                                </div>

                                <div class="form-group col-md-8">
                                    <label class="col-form-label required-field" for="inpApellidos">Apellidos</label>
                                    <input class="form-control" formControlName="Apellidos" maxlength="100"
                                           inputStyleClass="form-control" type="text" value="" [ngClass]="displayFieldCss('Apellidos')">

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('Apellidos','required')">
                                        Los Apellidos son obligatorios
                                    </div>

                                </div>

                            </div>

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label required-field" for="inpFecha">NIF</label>
                                    <input formControlName="Nif" name="Nif" class="form-control" maxlength="17"
                                           inputStyleClass="form-control" type="text" value="" [ngClass]="displayFieldCss('Nif')">

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('Nif','required')">
                                        El NIF es obligatorio
                                    </div>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Nif','NIF')">
                                        Formato de NIF incorrecto
                                    </div>

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('Nif','nif_duplicated')">
                                        El NIF ya existe en la base de datos
                                    </div>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label required-field" for="inpEmail">Email</label>
                                    <input class="form-control" formControlName="Email" maxlength="100" inputStyleClass="form-control"
                                           type="text" value="" [ngClass]="displayFieldCss('Email')">

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('Email','required')">
                                        El email es obligatorio
                                    </div>

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('Email','email')">
                                        Formato incorrecto
                                    </div>

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('Email','email_duplicated')">
                                        El email ya existe en la base de datos
                                    </div>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpActivo">Activo</label>
                                    <p-toggleButton class="form-control-togglebutton" formControlName="Activo" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>

                                    <!--<div class="invalid-feedback" *ngIf="isFieldInvalid('Apellidos','requiredTrue')">
                                    aceptar los tér
                                </div>-->

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('Activo', 'required')">
                                        Debe aceptar los términos y condiciones para continuar.
                                    </div>
                                </div>

                            </div>

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpFechaCreacion">Fecha Creación</label>
                                    <p-calendar formControlName="FechaCreacion" inputStyleClass="form-control" utc="true"
                                                [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy">
                                    </p-calendar>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpFechaActivacion">Fecha Activación</label>
                                    <p-calendar formControlName="FechaActivacion" inputStyleClass="form-control" utc="true"
                                                [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy">
                                    </p-calendar>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpFechaBaja">Fecha Baja</label>
                                    <p-calendar formControlName="FechaBaja" inputStyleClass="form-control" utc="true"
                                                [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy">
                                    </p-calendar>
                                </div>

                            </div>

                            <!--AUTORIZADOS IMPOR y EXPOR-->
                            <div *ngIf="mostrarDatosInspector" class="row">

                                <div class="form-group col-md-2">
                                    <label class="col-form-label" for="inpActivo">Autorizado Importación</label>
                                    <p-toggleButton class="form-control-togglebutton" formControlName="AutorizadoImportacion" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                                </div>

                                <div class="form-group col-md-2">
                                    <label class="col-form-label" for="inpActivo">Autorizado Exportación</label>
                                    <p-toggleButton class="form-control-togglebutton" formControlName="AutorizadoExportacion" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>

        <div class="row">

            <div class="col-md-4">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-header-buscador">
                        <i class="fa fa-plus"></i> <strong id="stPerfil">Perfiles</strong>
                        <!--@adua comentar clase en ngclass-->
                        <!--<label class="col-form-label" for="stPerfil"
                    [ngClass]="required-field"></label>-->
                        <label class="col-form-label required-field" for="stPerfil"></label>
                    </div>
                    <div class="card-body-detalle-list">

                        <div class="row">
                            <div class="col-md-12">

                                <div class="form-group">
                                    <div class="input-group">

                                        <!-- [items]="listPerfiles | async" -->

                                        <ng-select class="ngselect-listbox" [(items)]="listPerfiles"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdPerfil"
                                                   loadingText="Cargando..."
                                                   [loading]="!listPerfiles"
                                                   notFoundText="Perfil no encontrado"
                                                   placeholder="-- Seleccione un Perfil --"
                                                   clearAllText="Eliminar selección"
                                                   [ngClass]="displayFieldCssNgSelect('IdPerfil')">
                                        </ng-select>

                                        <span class="input-group-btn">
                                            &nbsp;<button name="btnAddPerfil" class="btn btn-list btn-secondary btn-listbox"
                                                          type="button" title="Añade un Perfil" (click)="onAddPerfil()"><i class="fa fa-plus"></i>
                                                  </button>
                                        </span>                                        

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">

                            <div class="col-md-12">

                                <label class="cabeceraTablaDetalles">Perfiles</label>
                                <table class="table table-list table-sm">
                                    <!-- table-responsive -->
                                    <tbody>
                                        <tr *ngFor="let item of usuario.TUsuarioPerfilCollection">
                                            <td scope="col">
                                                <div class="btn-group">

                                                    <button (click)="onDeletePerfil(item)" type="button" title="Eliminar perfil"
                                                            class="btn btn-sm btn-danger btn-listbox">
                                                        <i class="fa fa-remove"></i>

                                                    </button>
                                                </div>
                                            </td>

                                            <td scope="col" class="td-list">{{item.Descripcion}}</td>
                                        </tr>

                                    </tbody>
                                </table>

                                <div class="invalid-feedback-collectionlist d-block" *ngIf="isFieldInvalidNoSubmit('IdPerfil','required')">
                                    * Debe especificar un perfil.
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <div class="col-md-4" *ngIf="mostrarPuntosInspeccion">
                <!-- -->

                <div class="card card-accent-success animated fadeIn">
                    <div class="card-header-buscador form-inline">
                        <div class="col-md-6">
                            <i class="fa fa-plus"></i> <strong id="stPif">Puntos Inspección</strong>
                            <!--@adua comentar clase en ngclass-->
                            <!--<label class="col-form-label" for="stPerfil"
                                [ngClass]="required-field"></label>-->
                            <label class="col-form-label required-field" for="stPif"></label>
                        </div>                        
                        <div class="col-md-6">
                            <button type="button" class="btn btn-list btn-secondary btn-listbox" (click)="onAddAllPifs()" title="Añade todos los PIFs"><i class="fa fa-plus-square-o"></i> Añadir todos PIFs</button>
                        </div>
                    </div>
                    <div class="card-body-detalle-list">

                        <div class="row">
                            <div class="col-md-12">

                                <div class="form-group">

                                    <div class="input-group">

                                        <ng-select class="ngselect-listbox" [(items)]="listPuntosInspeccion"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdPuntoInspeccion"
                                                   loadingText="Cargando..."
                                                   [loading]="!listPuntosInspeccion"
                                                   notFoundText="PIF no encontrado"
                                                   placeholder="-- Seleccione un PIF --"
                                                   clearAllText="Eliminar selección"
                                                   [ngClass]="displayFieldCssNgSelect('IdPuntoInspeccion')">
                                            <ng-template ng-option-tmp let-item="item">
                                                <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                            </ng-template>
                                        </ng-select>

                                        <button name="btnAddPuntoInspeccion" class="btn btn-list btn-secondary btn-listbox"
                                                type="button" title="Añade un punto de inspección" (click)="onAddPuntoInspeccion()">
                                            <i class="fa fa-plus"></i>
                                        </button>

                                        <!--<label class="col-form-label" style="margin-top:5px">ó Puntos de inspección por provincia</label>-->
                                        <ng-select class="ngselect-listbox" style="padding-top:10px" [(items)]="listProvincias"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdProvincia"
                                                   loadingText="Cargando..."
                                                   [loading]="(!listProvincias && (form.value.IdZona > 0))"
                                                   notFoundText="Provincia no encontrada"
                                                   placeholder="-- Seleccione una Provincia --"
                                                   clearAllText="Eliminar selección"
                                                   [ngClass]="displayFieldCssNgSelect('IdProvincia')">
                                        </ng-select>

                                        <button name="btnAddPuntoInspeccionPorProvincia" class="btn btn-list btn-secondary btn-listbox" style="margin-top:10px"
                                                type="button" title="Añade los puntos de inspección de una provincia" (click)="onAddPuntoInspeccionPorProvincia()">
                                            <i class="fa fa-plus"></i>
                                        </button>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">

                            <div class="col-md-12">

                                <label class="cabeceraTablaDetalles">Puntos de Inspección</label>

                                <table class="table table-list table-sm">
                                    <!--table-responsive-->
                                    <tbody>
                                        <tr *ngFor="let item of sortByPif('descripcion')">
                                            <td scope="col">
                                                <div class="btn-group">

                                                    <button (click)="onDeletePuntoInspeccion(item)" type="button"
                                                            class="btn btn-sm btn-danger btn-listbox" title="Eliminar">
                                                        <i class="fa fa-remove"></i>

                                                    </button>
                                                </div>
                                            </td>

                                            <td scope="col" class="td-list">{{item.Descripcion}}</td>
                                        </tr>

                                    </tbody>
                                </table>

                                <div class="invalid-feedback-collectionlist d-block" *ngIf="isFieldInvalidNoSubmit('IdPuntoInspeccion','required')">
                                    * Debe especificar un PIF.
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <div class="col-md-4" *ngIf="mostrarDatosComunidad">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-header-buscador">
                        <i class="fa fa-plus"></i> <strong id="stDatosCa">Datos Comunidad Autónoma</strong>
                        <label class="col-form-label" for="stDatosCa" [ngClass]="{ 'required-field' : mostrarDatosComunidad }"></label>
                    </div>
                    <div class="card-body-detalle-list">
                        <div class="row">
                            <div class="form-group col-md-12">
                                <!--<label class="col-form-label" for="inpComAut">Comunidad Autónoma</label>-->
                                <ng-select [items]="listComAuts"
                                            bindLabel="Descripcion"
                                            bindValue="Id"
                                            formControlName="IdComunidadAutonoma"
                                            loadingText="Cargando..."
                                            [loading]="!listComAuts"
                                            notFoundText="Comunidad autónoma no encontrada"
                                            placeholder="-- Seleccione C. Autónoma --"
                                            clearAllText="Eliminar selección"
                                            [ngClass]="displayFieldCssNgSelect('IdComunidadAutonoma')">
                                </ng-select>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdComunidadAutonoma','required')">
                                    Debe especificar una comunidad autónoma.
                                </div>                                    
                            </div>                            
                        </div>

                        <div class="row">
                            <div class="form-group col-md-6">
                                <label class="col-form-label" style="margin-top:10px" for="inpActivo">Autorizado para Exportación</label>
                                <p-toggleButton class="form-control-togglebutton" formControlName="AutorizadoCertificacionEx" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                            </div>
                            <div class="form-group col-md-6">
                                <label class="col-form-label" style="margin-top:10px" for="inpActivo">Autorizado para Campañas Espec.</label>
                                <p-toggleButton class="form-control-togglebutton" formControlName="AutorizadoCampanias" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

        </div>
    </div>
</form>
